/**
 * @generated SignedSource<<eac5be2e05ded4827be76f67576e8cf6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useItemMediaItems_viewInRoomPhotos$data = ReadonlyArray<{
  readonly __typename: "viewInRoomPhotos";
  readonly " $fragmentType": "useItemMediaItems_viewInRoomPhotos";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "useItemMediaItems_viewInRoomPhotos";
}>;
export type useItemMediaItems_viewInRoomPhotos$key = ReadonlyArray<{
  readonly " $data"?: useItemMediaItems_viewInRoomPhotos$data;
  readonly " $fragmentSpreads": FragmentRefs<"useItemMediaItems_viewInRoomPhotos">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useItemMediaItems_viewInRoomPhotos",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "viewInRoomPhotos",
  "abstractKey": null
};

(node as any).hash = "e91fe6ae0c411d64818dbf03b2ddbc48";

export default node;
